<template>
  <div v-if="open" class="modal" @click="this.$emit('close')">
    <div class="modal-content" @click.stop>
      <font-awesome-icon icon="xmark" class="exit" @click="this.$emit('close')" />

      <div class="modal-header">
        <h2>{{ order.name }}</h2>
      </div>
      <div class="modal-body">
        <div class="order-details">
          <p>Email: {{ order.email }}</p>
          <p>Placed at: {{ new Date(order.events.created_at).toLocaleDateString() }}</p>
          <p>Address: {{ order.delivery_data.address }}</p>
          <p>Store: {{ order.location }}</p>
          <p>Status: {{ order.delivery_data.status }}</p>
        </div>

        <div class="products-section">
          <h4 class="section-title">Products:</h4>
          <ul class="products-list">
            <li v-for="product in order.products" :key="product.id">
              <span> - {{ product.name }}</span>
            </li>
          </ul>
        </div>
      </div>
      <button class="btn" v-if="order.delivery_data.status === 'assigned'" @click="this.$emit('remove')">Remove from selected orders</button>
      <button class="btn btn-primary action-colour" v-if="order.delivery_data.status === 'assigned'" @click="this.$emit('markAsDelivered')">Mark as Delivered</button>

      <div class="delivery-info" v-if="order.delivery_data.status === 'delivered'">
        <p>Delivered At: {{ order.delivery_data.delivered_at }}</p>
        <p>Delivered By: {{ order.delivery_data.delivered_by }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderModal",
  data() {
    return {
      // Modal data can be defined here
    };
  },
  emits: ["close", "markAsDelivered", "remove"],
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    order: {
      type: Object,
      required: true,
    },
  },
  methods: {},
  watch: {},
};
</script>

<style scoped lang="scss">
@use "@monolith/styles";

.modal-content {
  .modal-header {
    h2 {
      text-transform: capitalize;
      color: var(--action-colour);
    }
  }
  .modal-body {
    p {
      margin: 10px 0;
      font-size: 16px;
      color: var(--text-colour);
    }

    li {
      list-style: none;
      margin: 5px 0;
    }
  }

  button {
    margin: 0.5rem;
  }

  .products-section {
    margin: 0.5rem 0.5rem;
    padding: 0.25rem;
    border-radius: 1rem;
    background-color: #2c2c2c31;

    .section-title {
      color: var(--action-colour);
      margin: 0.5rem;
    }
    ul {
      margin: 0.5rem 0;
      padding: 0 1rem;
      li {
        font-size: small;
        margin: 0.25rem 0;
        padding: 0.25rem 0;
      }
    }
  }
}
</style>
